import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { textContentPropTypes } from '../../../config/sectionHeader/sectionHeaderPropTypes';
import generateHeaderRichTextEditorId from '../../../utils/generateHeaderRichTextEditorId';

import HeaderTextEditor from '../HeaderTextEditor';
import HeaderText from '../HeaderText';

import styles from './HeaderTextContent.scss';

class HeaderTextContent extends Component {
  static propTypes = {
    isEditMode: PropTypes.bool,
    ...textContentPropTypes,
  };

  static defaultProps = {
    isEditMode: false,
  };

  render() {
    const { isEditMode, textContent, clientUuid } = this.props;
    const HeaderTextComponent = isEditMode ? HeaderTextEditor : HeaderText;

    return (
      <HeaderTextComponent
        id={generateHeaderRichTextEditorId(clientUuid)}
        content={textContent}
        className={styles.container}
      />
    );
  }
}

export default HeaderTextContent;
